export default "__VITE_ASSET__haYED$nt__"